import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { makeQueryClient } from './api/query'
import { ThemeProvider } from './components/theme'
import { initSentry, Sentry } from './lib/sentry'
import { config } from './config'
import './styles/tailwind.css'

// Initialize Sentry before anything else
initSentry()

const clerkPubKey = config.clerkPublishableKey
const queryClient = makeQueryClient()

async function render() {
  if (clerkPubKey) {
    const { ClerkProvider } = await import('@clerk/react')
    const { App } = await import('./app')
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <Sentry.ErrorBoundary fallback={ErrorFallback}>
          <BrowserRouter>
            <ThemeProvider>
              <QueryClientProvider client={queryClient}>
                <ClerkProvider publishableKey={clerkPubKey} afterSignOutUrl="/sign-in">
                  <App />
                </ClerkProvider>
              </QueryClientProvider>
            </ThemeProvider>
          </BrowserRouter>
        </Sentry.ErrorBoundary>
      </StrictMode>,
    )
  } else {
    const { AppNoAuth } = await import('./app-no-auth')
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <Sentry.ErrorBoundary fallback={ErrorFallback}>
          <BrowserRouter>
            <ThemeProvider>
              <QueryClientProvider client={queryClient}>
                <AppNoAuth />
              </QueryClientProvider>
            </ThemeProvider>
          </BrowserRouter>
        </Sentry.ErrorBoundary>
      </StrictMode>,
    )
  }
}

function ErrorFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        color: '#3e4134',
      }}
    >
      <h1 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '8px' }}>
        Something went wrong
      </h1>
      <p style={{ fontSize: '14px', color: '#6b6e60', marginBottom: '16px' }}>
        An unexpected error occurred. Our team has been notified.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '8px 16px',
          borderRadius: '8px',
          border: '1px solid #e4e5df',
          background: '#fff',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 500,
        }}
      >
        Reload page
      </button>
    </div>
  )
}

render()
